import { render, staticRenderFns } from "./ContinuousFilingTab.vue?vue&type=template&id=1f5ff646&scoped=true&"
import script from "./ContinuousFilingTab.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5ff646",
  null
  
)

export default component.exports